import { WarehouseTabs } from '../../../warehouse/pages/warehouse-list/enums/wh-tabs.enum';

export const TABS_CAN_CREATE_WH: WarehouseTabs[] = [WarehouseTabs.Active, WarehouseTabs.Inactive];
export const STATUS_KEY: string = 'status';
